/**
 * ArrayIcon/index.js
 * desc: array (list) data-type icon
 * note: type icon via IconButton; defaults its tooltip + accessible name to the
 *       data-type title. Exported as both the default and a named (ref-able) component.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


export const ArrayIcon = ({ tooltip, ref, ...props }) => {
    return (
        <IconButton ref={ ref } baseClassName="array icon" label={ tooltip || translate('icons.array.tooltip.text') } tooltip={ tooltip } { ...props }>
            <svg viewBox="0 0 8 10" xmlns="http://www.w3.org/2000/svg"><path d="M.15 9.477V.387h2.102v.695H.945v7.7h1.307v.695H.15Zm7.7-9.09v9.09H5.746v-.696h1.307V1.082H5.747V.386H7.85Z"/></svg>
        </IconButton>
    );
};


export default ArrayIcon;
